export default __webpack_public_path__ + "static/media/star.f184ea9a.png";